export default __webpack_public_path__ + "signup-backdrop-freelancer-tablet.3932b21e.jpg";